import script from "./ProductQuantitySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductQuantitySelector.vue?vue&type=script&setup=true&lang=js"

import "./ProductQuantitySelector.vue?vue&type=style&index=0&id=5cfb4283&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfb4283"]])

export default __exports__